import React from 'react';
import { Dimensions, FlatList, Image, TouchableOpacity, View } from 'react-native';
import { ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { SCREEN_SIZE, } from '@voltmoney/types';
import { Typography } from '../../typography/Typography';
import { Icon } from '../../icon/Icon';
import { Divider } from "../../divider/Divider";
import { isFromTDLPlatform } from '../utils';
const ManageLoanDetails = ({ height, triggerAction, accountDetailsAction, transactionDetailsAction, manageLimitAction, trackLoanStatusAction, showAccountDetails, showTransactionHistory, showManageLimit, showTrackLoanClosure, showForeclosureTracking, foreclosureTrackingResponse }) => {
    const isfromTDL = isFromTDLPlatform();
    const data = [
        showAccountDetails && {
            iconUrl: IconTokens.Account_profile,
            imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icn-transaction-history.png",
            title: "Account details",
            action: accountDetailsAction
        },
        showTransactionHistory && {
            iconUrl: IconTokens.TRANSACTION_PLATFORM,
            imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icn-transaction-history.png",
            title: "Transaction history",
            action: transactionDetailsAction
        },
        showManageLimit && {
            iconUrl: IconTokens.ManageLimit,
            imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icn-transaction-history.png",
            title: "Manage limit",
            action: manageLimitAction
        },
        showTrackLoanClosure && showForeclosureTracking && {
            iconUrl: IconTokens.foreclosure,
            imageUrl: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icn-transaction-history.png",
            title: "Loan closure",
            action: trackLoanStatusAction
        },
    ].filter(item => item);
    const renderIndividualItem = (item, index, dataLength) => {
        const showDivider = index !== dataLength - 1;
        return (React.createElement(View, null,
            React.createElement(TouchableOpacity, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingVertical: 16,
                    alignContent: 'center',
                    alignItems: 'center'
                }, onPress: () => {
                    triggerAction({
                        ...item?.action
                    });
                } },
                React.createElement(View, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                    item.iconUrl ?
                        React.createElement(View, { style: { marginRight: 12 } },
                            React.createElement(Icon, { name: item?.iconUrl, size: IconSizeTokens.XXXXL, color: ColorTokens.Primary_100 }))
                        :
                            React.createElement(Image, { source: { uri: item.imageUrl }, style: { width: 32, height: 32, marginRight: 12 } }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0M, label: item?.title })),
                React.createElement(View, null,
                    React.createElement(Icon, { name: IconTokens.RightBlackIcon, size: IconSizeTokens.XL }))),
            showDivider ? React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }) : React.createElement(React.Fragment, null)));
    };
    return (React.createElement(View, { style: { padding: 16, backgroundColor: 'white', marginHorizontal: -16, marginBottom: 16 } },
        React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3B, label: "Manage loan", color: ColorTokens.Grey_Night }),
        React.createElement(FlatList, { data: data, renderItem: ({ item, index }) => renderIndividualItem(item, index, data.length), style: { marginTop: 16, ...isfromTDL && { borderWidth: 1, borderRadius: 12, borderColor: '#78787D3D', paddingHorizontal: 16 } } })));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
export default ManageLoanDetails;
